/**
 * @description header6 button menu
 * @author cycleccc
 */

import HeaderButtonMenuBase from './HeaderButtonMenuBase'

class Header6ButtonMenu extends HeaderButtonMenuBase {
  title = 'H6'

  type = 'header6'
}

export default Header6ButtonMenu
